import * as React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorFallback(_ref) {
  let {
    error,
    componentStack,
    resetErrorBoundary
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    role: "alert",
    children: [/*#__PURE__*/_jsx("p", {
      children: "Something went wrong:"
    }), /*#__PURE__*/_jsx("pre", {
      children: error === null || error === void 0 ? void 0 : error.message
    }), /*#__PURE__*/_jsx("pre", {
      children: componentStack
    }), /*#__PURE__*/_jsx("button", {
      onClick: resetErrorBoundary,
      children: "Try again"
    })]
  });
}
export const ErrorBoundary = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_jsx(ReactErrorBoundary, {
    FallbackComponent: ErrorFallback,
    children: children
  });
};